import React from 'react';
import { XyqarAuthProvider } from '@xyqar/shared-auth';
import AuthPage from './components/AuthPage';

const authConfig = {
  domain:      import.meta.env.VITE_AUTH0_DOMAIN   as string,
  clientId:    import.meta.env.VITE_AUTH0_CLIENT_ID as string,
  audience:    import.meta.env.VITE_AUTH0_AUDIENCE  as string ?? 'https://api.xyqar.com',
  redirectUri: window.location.origin,
};

export default function App() {
  return (
    <XyqarAuthProvider config={authConfig}>
      <AuthPage />
    </XyqarAuthProvider>
  );
}
